(()=>{
 if(window.BBCommunity)return;
 const root=()=>window.Shopify?.routes?.root||'/';
 const optedOut=()=>{try{return sessionStorage.getItem('bb-community-declined')==='true';}catch{return false;}};
 let cartPromise=fetch(root()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error('Unable to check membership');return r.json();}).catch(()=>null);
 window.BBCommunity={async prepare(){
   const data=document.querySelector('[data-bb-community-data]');
   if(!data||optedOut())return[];
   const line=JSON.parse(data.textContent);
   const cart=line.handle==='dr-white-community'?await fetch(root()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null):await cartPromise;
   if(!cart)return[];
   if(cart.items.some(item=>String(item.variant_id)===line.id))return[];
   return[line];
 }};
})();
